import { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../../Airoom.css';
import Datatable from "../../../core/common/dataTable/index";
import FilterComponent from "../../../core/common/FilterComponent";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Ribbon from "../../../core/common/ribbon/ribbon";
import CustomSelect from "../../../core/common/selectPirority/SelectPirority";
import { leadsData } from "../../../core/data/json/leadsData";
import "../../../style/css/index.css";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import FilterModalLeadsInquiry from "./FilterModalLeads";
import FilterModalLeads from "./FilterModalLeads";

const Leads = () => {

  const data = leadsData;
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);

  const navigate = useNavigate();
  const dropdownItems = [
    { id: '1', value: "High", label: "High" },
    { id: '3', value: "Medium", label: "Medium" },
    { id: '2', value: "Low", label: "Low" },
  ];
  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];
  const idValue = 'dropdownMenuClickableInsise1';
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }
  const handleClose = () => {
    setShowfilterModal(false)
  };
  const handlefilterManage = () => {
  };

  const handleViewDetails = () => {
    if (selectedRowId) {
      navigate(`/leadsUserDetails/${selectedRowId}`);
    } else {
      alert("Please select a row first.");
    }
  };
  const handleEditLead = () => {
    if (selectedRowId.length >= 1) {
      navigate(`/leadsUserDetails/${selectedRowId}`);
    }
  }
  const handleAddLead = () => {
    navigate('/addleadInquiry');
  }
  const navigateContacts = () => {
    navigate('/contacts');
  }
  const navigatenotes = () => {
    navigate('/notes');
  }
  const navigatedocuments = () => {
    navigate('/documents');
  }
  const navigateclientVisits = () => {
    navigate('/clientVisits');
  }
  const navigateTasks=()=>{
    navigate('/tasks');

  }
  const handleRowDoubleClick = (record: { id: any }) => {
    const id = record.id;
    navigate(`/leadsUserDetails/${id}`);
  };
  const items = [
    // { tooltipLabel: "Send To Sales Admin", icon: svgIcons.SendIcon, },
    {
      tooltipLabel: "Edit",
      icon: svgIcons.updateIcon,
      onClick: handleEditLead,
      disableButton: selectedRowId.length > 1 || selectedRowId.length === 0,
      disableIcon: svgIcons.disableUpdateIcon
    },
    { tooltipLabel: "View details", icon: svgIcons.eyeIcon, disableIcon: svgIcons.disableEyeIcon, onClick: handleViewDetails, disableButton: selectedRowId.length > 1 || selectedRowId.length === 0 },
    { label: "Priority:", icon: svgIcons.PirorityIcon, DropdownButton: <CustomSelect options={dropdownItems} /> },
    { tooltipLabel: "Contacts", icon: svgIcons.contactsIcon, },
    { tooltipLabel: "Documents", icon: svgIcons.documentIcon, },
    { tooltipLabel: "Notes", icon: svgIcons.NotesIcon, },
    { tooltipLabel: "Client Visits", icon: svgIcons.clientvisits, },
    { tooltipLabel: "Tasks", icon: svgIcons.TasksIcon, },
  ];
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
    },
    {
      title: "NAME",
      render: (text: any, record: any) => (
        <div className="table-avatar d-flex align-items-center">
          <div className="company-img">
            <ImageWithBasePath src={record.image} alt="UserImage" />
          </div>
          <div
            className="profile-split d-flex flex-column"
          >
            {record.customer_name}
            <span>{text.customer_no}</span>
          </div>
        </div>
      ),
      sorter: true,
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "CONTACT",
      dataIndex: "phone",
      key: "phone",
      sorter: true,
    },
    {
      title: "PRIORITY",
      dataIndex: "Pirority",
      render: (text: string) => (
        <div>
          {text === "Low" && (
            <span className="badge badge-pill badge-status bg-soft-success text-success ">
              <span>
                <i className="fa fs-10 fa-solid fa-circle"></i>
              </span>{" "}
              {text}
            </span>
          )}

          {text === "High" && (
            <span className="badge badge-pill badge-status bg-soft-danger text-danger">
              <span>
                <i className="fa fs-10 fa-solid fa-circle"></i>
              </span>{" "}
              {text}
            </span>
          )}
          {text === "Medium" && (
            <span className="badge badge-pill badge-status bg-soft-warning text-warning">
              <span>
                <i className="fa fs-10 fa-solid fa-circle"></i>
              </span>{" "}
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "CREATED AT",
      dataIndex: "created",
      key: "created",
      sorter: true,
    },
    // {
    //   title: "LAST MODIFIED",
    //   dataIndex: "created",
    //   key: "last_activity",
    //   sorter: true,
    // },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "Active" && (
            <span className="badge badge-pill badge-status bg-soft-success text-success">
              {text}
            </span>
          )}

          {text === "Inactive" && (
            <span className="badge badge-pill badge-status bg-soft-danger text-danger">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
  ];
  return (
    <>
    <FilterModalLeads show={showfilterModal} handleClose={handleClose}/>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                // buttonText="+ New Lead"
                buttonClass="add-popup ribbon-btn "
                // buttonPath="/addLead"
                Icon={svgIcons.importIcon}
                // onClickbtn={handleAddLead}
              />
              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row">
                      <div className="col-md-4 col-sm-8">
                        <h4 className="page-title color-red">All Leads</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="d-flex justify-content-end gap-2 ">
                          <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                        <div>
                          <div className=" icon-form">
                            <span className="form-icon">
                              <i className="ti ti-search" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Lead"
                            />
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    {/* <Datatable dataSource={data} columns={columns}  
                    onRowSelect={(record: any) => setSelectedRowId(record)}
                     /> */}
                    <Datatable dataSource={data} columns={columns} onRowSelect={(keys: any[]) => setSelectedRowId(keys)} onDoubleClick={handleRowDoubleClick} paginations={true} />

                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Manage Users List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Leads;



